import React, { useMemo } from 'react';
import { Row, Col } from '@dex/bubl-dash/src/lib/components/Layout/Layout';
import Panel from '@dex/bubl-dash/src/lib/components/Panel/Panel';
import { Form } from '@dex/bubl-dash/src/lib/functions/useForm';
import Line from '@dex/bubl-dash/src/lib/components/Line/Line';
import Button, { ButtonRow } from '@dex/bubl-dash/src/lib/components/Button/Button';

import FieldTextArea from '@dex/bubl-dash/src/lib/components/Fields/FieldTextArea'
import FieldRadio from '@dex/bubl-dash/src/lib/components/Fields/FieldRadio'
import FieldRelationship from '@dex/bubl-dash/src/lib/components/Fields/FieldRelationship'


const CommentCreateEditForm: React.FC<any> = (props: any) => {

    const { form, process, handleSubmit } = props;

    // eslint-disable-next-line
    let data = props.data || {};

    return useMemo(() => (

        <Panel
            heading={"Comment Details"}
        >

            <Form
                form={form}
                onSubmit={handleSubmit}
                loading={process.loading}
            >

                <Row gutter={8} edge={true}>

                    <Col col={{ xs: 24, md: 24 }} >

                        <FieldTextArea
                            form={form}
                            label={"Message"}
                            name='message'
                            required={true}
                            defaultValue={form.defaults.message}
                        />

                    </Col>

                    <Col col={{ xs: 24, md: 12 }}>

                        <FieldRadio
                            form={form}
                            label={"Status"}
                            name='status'
                            required={true}
                            defaultValue={form.defaults.status}
                            options={[
                                { value: "publish", label: "Publish" },
                                { value: "spam", label: "Spam" },
                            ]}
                        />

                    </Col>

                    <Col col={{ xs: 24, md: 24 }}>

                        <FieldRelationship
                            form={form}
                            label={"User"}
                            name='ownerId'
                            required={true}
                            preload={true}
                            endpoint={'Users'}
                            defaultValue={form.defaults.ownerId}
                        />

                    </Col>

                </Row>

                <Line />

                <ButtonRow>
                    <Button
                        label={"Submit"}
                        loading={process.loading}
                    />
                    <Button
                        label={"Reset"}
                        type={"faded"}
                        onClick={form.reset}
                    />
                </ButtonRow>

            </Form>

        </Panel>


    ), [props]);

}

export default CommentCreateEditForm;
